import React from 'react';
import WrappedBase from './WrappedBase';

import VariantPrice from '../containers/VariantPrice';

export default class VariantPriceWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <VariantPrice {...this.props} />
      </WrappedBase>
    );
  }
}
